export const wwcnModTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('CNWWScripts') !== -1 || desyncdata.indexOf('wwcommon') !== -1 || desyncdata.indexOf('sims4communitylib') !== -1 || desyncdata.indexOf('kinky') !== -1 || desyncdata.indexOf('wwpets') !== -1 || desyncdata.indexOf('deviousdesires') !== -1) {
			return {
				type: 'wwcnWarningModTest',
        nonError: true,
				color: 'IndianRed',
				title: 'ColonolNutty\'s Mod Warning',
				text: 'Offensive creator content recognized.',
				description: 'Due to community demand in recognizing offensive individuals in The Sims community, you are being warned about using content that is or was made by, associated with, or depends on the individual known as ColonolNutty.<br/>It\'s recommended to remove suspect mods to avoid issues.<br/><br/>To learn more about ColonolNutty\'s suspicious activities, consider reviewing the <a href="https://bit.ly/colonolnutty" target="_blank" rel="noopener noreferrer">relevant documentation by clicking here</a>.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>609ed1abc6af9be95c98f103</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-03-25 08:22:08</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.67.1020-1.200.000.385.Release</buildsignature>
        <categoryid>cnactive_sex_handler.py:39</categoryid>
        <desyncid>609ed1abc6af9be95c98f103</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception while running interaction  running TURBODRIVER:WickedWhims_Route_To_Sex_Destination:743 on None  (guaranteed) (AttributeError: 'SexAnimationInstance' object has no attribute 'get_actors_gender_list')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 205, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 463, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\time_service.py&quot;, line 112, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 217, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 385, in _resume
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 4034, in do_transition_single
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3990, in _create_transition_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3883, in run_super_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 3751, in run_direct_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 601, in run_interaction_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 4863, in perform_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 5810, in perform_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 5780, in perform_gen
  File &quot;Scripts/CNWWScripts\cncustom\wickedwhims\sex\sex_handlers\active\cnactive_sex_handler.py&quot;, line 183, in _cn_custom_handler_assign_actor
  File &quot;Scripts/CNWWScripts\cncustom\wickedwhims\sex\sex_handlers\active\cnactive_sex_handler.py&quot;, line 39, in assign_actor
AttributeError: 'SexAnimationInstance' object has no attribute 'get_actors_gender_list'
rtim=0</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/wwcnModTest.js